/** Notifications' part of "Download my data": the caller's files here (NTF-29). */
export const myDataApi = '/notifications/v1/me/data'
